
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import { Actions } from "@/store/enums/StoreEnums";
import { setCookie } from "typescript-cookie";

export default defineComponent({
  name: "dashboard",
  components: {},

  setup() {
    const supplierId = ref();
    const HideGT = ref(false);
    const HideYs = ref(false);
    const store = useStore();
    const router = useRouter();
    const Platform = ref();
    const UserName = ref();
    const Password = ref();
    const Branch = ref();
    const selectedBranch = ref();
    const selectedMenu = ref();
    const Menu = ref();
    const Hide = ref(false);
    const HideMenu = ref(false);
    // Yemeksepeti new-platform OTP flow
    const HideOtp = ref(false);
    const OtpCode = ref();
    const flowId = ref();
    const otpEmail = ref();
    const channelValue = ref();
    const ysAuth = ref();
    const okeybutton = async () => {
      if (Platform.value == "Getir") {
        await store
          .dispatch(Actions.GETIR_CHECK, {
            username: UserName.value,
            password: Password.value,
          })
          .then((r) => {
            if (r.status == 201) {
              Branch.value = r.data;
              Hide.value = true;
              HideGT.value = true;
            } else {
              Swal.fire({
                title: "Hata",
                text: "Getir kullanıcı adı ve şifre hatalı",
                icon: "error",
                confirmButtonText: "Tamam",
              });
            }
          });
      }
      if (Platform.value == "Yemeksepeti") {
        store
          .dispatch(Actions.YEMEKSEPETI_CHECK, {
            username: UserName.value,
            password: Password.value,
          })
          .then((r) => {
            if (r.status == 201) {
              Hide.value = true;
              if (r.data.otpRequired) {
                // OTP step: code sent to the account's email/phone
                flowId.value = r.data.flowId;
                otpEmail.value = r.data.email;
                channelValue.value = r.data.channelValue;
                HideOtp.value = true;
              } else {
                // Trusted device: tokens + branches returned directly
                ysAuth.value = r.data.auth;
                Branch.value = r.data.branches;
                HideYs.value = true;
              }
            } else {
              Swal.fire({
                title: "Hata",
                text: "Yemeksepeti kullanıcı adı ve şifre hatalı",
                icon: "error",
                confirmButtonText: "Tamam",
              });
            }
          });
      }
      if (Platform.value == "Trendyol") {
        await store
          .dispatch(Actions.TRENDYOL_CHECK, {
            supplierId: supplierId.value,
            apiKey: UserName.value,
            apiSecret: Password.value,
          })
          .then((r) => {
            if (r.status == 201) {
              Branch.value = r.data;
              Hide.value = true;
              HideGT.value = true;
              console.log(Branch.value);
            } else {
              Swal.fire({
                title: "Hata",
                text: "Trendyol kullanıcı adı ve şifre hatalı",
                icon: "error",
                confirmButtonText: "Tamam",
              });
            }
          });
      }
    };
    const sendgetir = async (type: string) => {
      const data = {
        updatefor: type,
        Credentials: {
          username: UserName.value,
          password: Password.value,
          selectedBranch: selectedBranch.value,
        },
      };
      await store.dispatch(Actions.ADDNEWCREDENTIAL, data).then((res) => {
        if (res.status == 201) {
          setCookie("access_token", res.data.access_token);
          setCookie("refresh_token", res.data.refresh_token);
          router.push({ name: "dashboard" });
        } else {
          router.push({ name: "sign-in" });
        }
      });
    };
    const sendtrendyol = async (type: string) => {
      const data = {
        updatefor: type,
        Credentials: {
          supplierId: supplierId.value,
          apiKey: UserName.value,
          apiSecret: Password.value,
          selectedBranch: selectedBranch.value,
        },
      };
      await store.dispatch(Actions.ADDNEWCREDENTIAL, data).then((res) => {
        if (res.status) {
          setCookie("access_token", res.data.access_token);
          setCookie("refresh_token", res.data.refresh_token);
          router.push({ name: "dashboard" });
        } else {
          router.push({ name: "sign-in" });
        }
      });
    };
    const verifyOtp = async () => {
      const r: any = await store.dispatch(Actions.YEMEKSEPETI_VERIFY_OTP, {
        email: otpEmail.value,
        flowId: flowId.value,
        otpCode: OtpCode.value,
      });
      if (r && r.status == 201) {
        ysAuth.value = r.data.auth;
        Branch.value = r.data.branches;
        HideOtp.value = false;
        HideYs.value = true;
      } else {
        Swal.fire({
          title: "Hata",
          text: "Doğrulama kodu hatalı veya süresi dolmuş. Lütfen tekrar deneyin.",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      }
    };
    const sendyemeksepeti = async (type: string) => {
      const data = {
        updatefor: type,
        Credentials: {
          username: UserName.value,
          password: Password.value,
          selectedBranch: selectedBranch.value,
          selectedMenuId: selectedMenu.value,
        },
      };
      await store.dispatch(Actions.ADDNEWCREDENTIAL, data).then(async (res) => {
        if (res.status == 201) {
          setCookie("access_token", res.data.access_token);
          setCookie("refresh_token", res.data.refresh_token);
          // Persist the new-platform Yemeksepeti tokens for this user.
          if (ysAuth.value) {
            await store.dispatch(Actions.SAVE_YEMEKSEPETI_AUTH, {
              auth: ysAuth.value,
            });
          }
          router.push({ name: "dashboard" });
        } else {
          router.push({ name: "sign-in" });
        }
      });
    };
    onMounted(() => {
      setCurrentPageTitle("Yeni Entegrasyon");
    });
    return {
      sendgetir,
      supplierId,
      sendtrendyol,
      sendyemeksepeti,
      verifyOtp,
      Hide,
      selectedMenu,
      HideYs,
      HideMenu,
      HideGT,
      HideOtp,
      OtpCode,
      flowId,
      otpEmail,
      channelValue,
      ysAuth,
      selectedBranch,
      okeybutton,
      Platform,
      UserName,
      Password,
      Branch,
      Menu,
    };
  },
});
